<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="7">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model.trim="form.searchKey"
              :placeholder="
                $l('from_label_parameter_id_name') || '参数ID/参数名称搜索……'
              "
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                  >
                    {{ $l('INDEX.advanced_search') || '高级搜索' }}
                  </b-button>
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
            <b-button
              size="sm"
              class="ml-2"
              variant="outline-success"
              @click="$emit('openEditFormDialog', { type: 'add' })"
              v-if="allow('A')"
            >
              <!-- <b-icon-plus></b-icon-plus> -->
              {{ $l('INDEX.btn_add') || '新增' }}
            </b-button>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
    <el-dialog
      :title="$l('INDEX.advanced_search') || '高级搜索'"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      width="500px"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="form" size="medium">
        <el-form-item :label="$l('table_label_parameter_name') || '参数名称'">
          <el-input
            v-model.trim="form.paramName"
            :placeholder="
              $l('form_label_pe_parameter_name') || '请输入参数名称'
            "
            clearable
            size="small"
          >
          </el-input>
        </el-form-item>
        <el-form-item :label="$l('form_label_parameter_id') || '参数ID'">
          <el-input
            v-model.trim="form.paramID"
            :placeholder="$l('form_label_pe_parameter_id') || '请输入参数ID'"
            clearable
            size="small"
          >
          </el-input>
        </el-form-item>
        <el-row>
          <el-form-item :label="$l('from_label_state') || '状态'">
            <el-col>
              <el-checkbox-group v-model="form.paramStatusList">
                <el-checkbox label="Y">{{
                  $l('form_radio_Effective') || '有效'
                }}</el-checkbox>
                <el-checkbox label="N">{{
                  $l('form_radio_invalid') || '无效'
                }}</el-checkbox>
              </el-checkbox-group>
            </el-col>
          </el-form-item>
        </el-row>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog">{{
          $l('INDEX.btn_cancel_query') || '取消查询'
        }}</el-button>
        <el-button size="small" type="warning" @click="reset">{{
          $l('INDEX.btn_reset_filter') || '重置条件'
        }}</el-button>
        <el-button size="small" type="primary" @click="advquery">{{
          $l('INDEX.btn_data_retrieval') || '数据检索'
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// 初始表单
const initForm = {
  searchKey: '',
  paramStatusList: ['Y']
}

export default {
  data() {
    return {
      advqueryDialogVisible: false,
      form: { ...initForm }
    }
  },
  created() {
    this.query()
  },
  methods: {
    fromLoad(val) {
      this.$emit(val)
    },
    // 初始查询
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      this.$emit('query', this.form)
    },
    // 高级查询
    advquery() {
      this.form.searchKey = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    // 重置查询条件 - 高级查询
    reset() {
      this.form = { ...initForm }
    },
    // 打开高级查询
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    // 关闭高级查询
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    }
  }
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
